import React from 'react'
import { components } from 'react-select'
import { Col } from 'react-bootstrap'
import type { SelectAsyncProps } from '@ztechapps/webui.input'
import { SelectAsync } from '@ztechapps/webui.input'
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { LocalDate } from '@ztechapps/webui.date'
import { HorizontalStack } from '@ztechapps/webui.util'
import { OrderStatus } from '../StatusBadge'

export const queries = buildGraphqlQuery(
  'Order',
  `_id code summary status createdAt relatedOrders { _id } by { _id company { _id name } }`
)

//endregion

const Option = ({ data, ...rest }: any) => {
  //always set the isSelected to false so it wont highlight
  return (
    <components.Option {...{ ...rest, data, isSelected: false }}>
      <HorizontalStack gap={2}>
        <div className="flex-shrink-0 text-nowrap">
          <HorizontalStack gap={0}>
            <OrderStatus status={data?.status} />
            <div className="fw-bold">{data?.code}</div>
          </HorizontalStack>
        </div>

        <Col className="text-truncate">
          <small>{data?.by?.company?.name || '--'}</small>
        </Col>

        <div className="flex-shrink-0 text-nowrap text-body-secondary">
          <small>
            <LocalDate value={data?.createdAt} />
          </small>
        </div>
      </HorizontalStack>
    </components.Option>
  )
}

const dataLoadOptions = ({ filter }) => ({
  query: queries.allConfig.query,
  filter: ({ input }) => ({
    $or: [{ code: { $regex: input, $options: 'i' } }, { summary: { $regex: input, $options: 'i' } }],
    ...filter,
  }),
  resultFieldName: 'allOrder',
  options: () => ({
    sort: { createdAt: -1 as const },
  }),
})

export const OrderSelect = ({ filter, ...rest }: SelectAsyncProps) => {
  return (
    <SelectAsync
      {...{
        ...rest,
        components: { Option },
        placeholder: 'Type order code or name',
        labelKey: 'code',
        noOptionsMessage: () => 'Cannot find any orders.',
        dataLoadOptions: dataLoadOptions({ filter }),
      }}
    />
  )
}
